import { EventCategory } from "../models/EventCategory";
import api from "./api";
import { clean } from "../utils/utils";

const BASE_PATH = "/api/v1/event-categories";

export const EventCategoryService = {
  async getEventCategories(): Promise<EventCategory[]> {
    const res = await api.get(`${BASE_PATH}`);
    return res.data.data ?? [];
  },

  async createEventCategory(
    matterId: string,
    eventCategoryData: Omit<EventCategory, "_id">,
  ): Promise<string> {
    const res = await api.post(`${BASE_PATH}`, {
      ...clean(eventCategoryData),
      matter: matterId,
    });
    return res.data?.data?._id;
  },

  async updateEventCategory(
    eventCategoryId: string,
    updatedData: Partial<EventCategory>,
  ): Promise<void> {
    await api.patch(`${BASE_PATH}/${eventCategoryId}`, updatedData);
  },

  async deleteEventCategory(eventCategoryId: string): Promise<void> {
    await api.delete(`${BASE_PATH}/${eventCategoryId}`);
  },
};
